import { useRef } from 'react';
import { useZusModalStore, ModalWrapper } from '@/helpers/modal.js';
import { getScript } from '@/helpers/common.js';

const TypeForm = ({ children }) => {
  const { setModal1 } = useZusModalStore.getState();
  const divRef = useRef();

  function openTypeForm(url) {
    // eslint-disable-next-line no-undef
    typeformEmbed.makeWidget(divRef.current, url, {
      hideFooter: true,
      hideHeaders: true,
      hideScrollbars: true,
    });
  }
  async function onClick(url) {
    if (typeof typeformEmbed === 'undefined') {
      await new Promise((resolve) => {
        getScript('https://embed.typeform.com/embed.js', () => {
          resolve(true);
        });
      });
    }
    const content = <ModalWrapper onClose={() => setModal1(null)} afterRender={() => openTypeForm(url)} delay={1}><div className="h-70v min-w-600 rounded-2xl overflow-hidden" ref={divRef} /></ModalWrapper>;
    setModal1(content);
  }

  return children({ openTypeForm: (url) => onClick(url) });
};

export default TypeForm;
